<template>
  <div>
    <b-modal
      ref="deskShareModal"
      title="Install Extension"
      ok-title="Install Now"
      cancel-title="Cancel"
      button-size="sm"
      ok-variant="primary-light"
      cancel-variant="secondary-light"
      content-class="bg-light light"
      body-class="light py-2 px-4"
      @ok="openWindow"
    >
      <p>{{ $t('MEETING.DESKSHARE_INSTALL') }}</p>
    </b-modal>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api"
import { getItem } from "../functions/storageManager"
export default {
  name: 'DesktopSharing',
  setup(props, context) {
    let chromeExtInstalled = false
    let href = 'https://chrome.google.com/webstore/detail/' + window['webrtc-config'].chromeId
    const backgroundColor = ref('light')
    const textColor = ref('dark')

    function openWindow() {
      window.open(href, "_blank");
      context.refs.deskShareModal.hide()
  }

    function checkExtensionInstalled (callback) {
      if (!window.chrome.runtime) {
        chromeExtInstalled = false
        callback()
      } else {
        if (chromeExtInstalled) {
          callback()
        } else {
          window.chrome.runtime.sendMessage(window['webrtc-config'].chromeId,
            {getVersion: true},
            response => {
              // check if latest version is installed
              if (!response || !response.version) {
                chromeExtInstalled = false
              } else {
                chromeExtInstalled = true
              }
              callback()
            }
          )
        }
      }
    }

    function startDesktopSharing () {
      window.chrome.runtime.sendMessage(window['webrtc-config'].chromeId,
        {getStream: true},
        function (response) {
          if (!response || !response.streamId) {
            context.parent.$refs.meetingControls.desktop = false
          } else {
            sharing(response)
          }
        }
      )
    }

    async function sharing (response) {
      let screenConstraints = {
        mandatory: {
          chromeMediaSource: 'desktop',
          chromeMediaSourceId: response.streamId,
          maxWidth: window.screen.width,
          maxHeight: window.screen.height,
          maxFrameRate: 10
        },
        optional: []
      }
      let mediaConstraints = {
        'audio': false, 'video': screenConstraints
      }
      let mediaStream = await navigator.mediaDevices.getUserMedia(mediaConstraints).catch((error) => {
        context.root.$notify.error('Access to the media failed:' + error)
      })
      if (mediaStream) {
        let index = context.parent.localVideoStreams.findIndex(sender => sender.source == 'desktop')
        context.parent.localVideoStreams[index].media.getTracks().forEach( track => {
          track.stop()
          context.parent.localVideoStreams[index].media.removeTrack(track)
        })
        mediaStream.getTracks()[0].enabled = true
        let deskTrans = context.parent.session.connection.getTransceivers().find( trans => trans.mid == context.parent.localVideoStreams[index].mid)
        await deskTrans.sender.replaceTrack(mediaStream.getVideoTracks()[0])
        context.parent.localVideoStreams[index].media = mediaStream
        context.parent.localVideoStreams[index].active = true
        if (context.parent.maxBw > 0) {
          context.parent.setMaxBw(context.parent.maxBw)
        }
      }
    }

    async function shareDesktop () {
      let index = context.parent.localVideoStreams.findIndex(sender => sender.source == 'desktop')
      if (context.parent.browser.chrome) {
        checkExtensionInstalled(() => {
          if (chromeExtInstalled) {
            startDesktopSharing()
          } else {
            if (getItem('mode') !== undefined) {
              if(getItem('mode') == 'dark') {
                backgroundColor.value = 'dark'
                textColor.value = 'light'
              } else {
                backgroundColor.value = 'light'
                textColor.value = 'dark'
              }
            }
            context.refs.deskShareModal.show()
            context.parent.$refs.meetingControls.desktop = false
          }
        })
      } else if (context.parent.browser.edge) {
        let constraints = {
          video: true
        }
        let mediaStream = await navigator.getDisplayMedia(constraints).catch((error) => {
          context.root.$notify.error('Access to the media failed:' + error.name)
        })
        if (mediaStream) {
          context.parent.localVideoStreams[index].media.getTracks().forEach( track => {
            track.stop()
            context.parent.localVideoStreams[index].media.removeTrack(track)
          })
          mediaStream.getVideoTracks()[0].enabled = true
          let deskTrans = context.parent.session.connection.getTransceivers().find( trans => trans.mid == context.parent.localVideoStreams[index].mid)
          await deskTrans.sender.replaceTrack(mediaStream.getVideoTracks()[0])
          context.parent.localVideoStreams[index].media = mediaStream
          context.parent.localVideoStreams[index].active = true
          if (context.parent.maxBw > 0) {
            context.parent.setMaxBw(context.parent.maxBw)
          }
        } else {
          context.parent.$refs.meetingControls.desktop = false
        }
      } else {
        let screenConstraints = {
          audio: false,
          video: {
            mozMediaSource: context.parent.$refs.meetingControls.selectedShareOption,
            mediaSource: context.parent.$refs.meetingControls.selectedShareOption
          }
        }
        let mediaStream = await navigator.mediaDevices.getUserMedia(screenConstraints).catch((error) => {
          context.root.$notify.error('Access to the media failed:' + error)
        })
        if (mediaStream) {
          context.parent.localVideoStreams[index].media.getTracks().forEach( track => {
            track.stop()
            context.parent.localVideoStreams[index].media.removeTrack(track)
          })
          mediaStream.getVideoTracks()[0].enabled = true
          let deskTrans = context.parent.session.connection.getTransceivers().find( trans => trans.mid == context.parent.localVideoStreams[index].mid)
          await deskTrans.sender.replaceTrack(mediaStream.getVideoTracks()[0])
          context.parent.localVideoStreams[index].media = mediaStream
          context.parent.localVideoStreams[index].active = true
          if (context.parent.maxBw > 0) {
            context.parent.setMaxBw(context.parent.maxBw)
          }
        }
      }
    }

    function stopSharing () {
      let index = context.parent.localVideoStreams.findIndex(sender => sender.source == 'desktop')
      context.parent.localVideoStreams[index].media.getTracks().forEach( track => {
        track.enabled = false
        track.stop()
        context.parent.localVideoStreams[index].media.removeTrack(track)
      })
      let deskTrans = context.parent.session.connection.getTransceivers().find( trans => trans.mid == context.parent.localVideoStreams[index].mid)
      deskTrans.sender.replaceTrack(null)
      //context.parent.session.connection.getSenders()[2].replaceTrack(null)
      context.parent.$refs.meetingControls.desktop = false
      if (context.parent.maxBw > 0) {
        context.parent.setMaxBw(context.parent.maxBw)
      }
      context.parent.localVideoStreams[index].active = false
    }

    return {
      openWindow,
      backgroundColor,
      textColor,
      shareDesktop,
      stopSharing
    }

  }
}
</script>

<style>
.light .modal-header {border-color: transparent}
.light .modal-footer {border-color: transparent}
</style>


// WEBPACK FOOTER //
// src/components/Desktop.vue